import { useParams } from 'react-router';
import { Container, Paper, useMediaQuery, useTheme } from '@mui/material';

import { PermissionedView } from '@cvt/components/Permissioned';
import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { ViewDiscipline as ViewDisciplineView } from '@modules/Disciplines/views/ViewDiscipline';

export const ViewDiscipline = () => {
  const { disciplineId = '' } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container
      disableGutters
      maxWidth="sm"
      sx={{
        py: {
          sm: 3,
        },
      }}
    >
      <Paper
        variant="elevation"
        elevation={1}
        sx={isMobile ? {
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
        } : {
          overflow: 'hidden',
        }}
      >
        <ErrorBoundary>
          <PermissionedView permission="majors.view">
            <ViewDisciplineView
              id={parseInt(disciplineId, 10)}
            />
          </PermissionedView>
        </ErrorBoundary>
      </Paper>
    </Container>
  );
};
